import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class EmailServices {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async enviarEmailAdjunto(remitenteEmail, destinatarioEmail , ccEmail, asunto, cuerpo, nombreArchivo, formatoArchivo, pdfHex){
    
    let resultadoInsert={message: 'OK'} 

    const bodyEmail={
      "remitenteEmail": remitenteEmail,
      "destinatarioEmail": destinatarioEmail,
      "ccEmail": ccEmail,
      "asunto": asunto,
      "cuerpo": cuerpo,
      "nombreArchivo": nombreArchivo,
      "formatoArchivo": formatoArchivo,     
      "pdfHex": pdfHex
    }

    resultadoInsert = await this.apiService.enviarEmailAdjunto(bodyEmail)
    
    return resultadoInsert
  }

  async enviarEmail(remitenteEmail, destinatarioEmail , ccEmail, asunto, cuerpo){
    
    let resultadoInsert={message: 'OK'} 

    const bodyEmail={
      "remitenteEmail": remitenteEmail,
      "destinatarioEmail": destinatarioEmail,
      "ccEmail": ccEmail,
      "asunto": asunto,
      "cuerpo": cuerpo
    }

    resultadoInsert = await this.apiService.enviarEmail(bodyEmail)
    
    return resultadoInsert
  }

}

export default EmailServices
